// src/config.js
export const API_BASE_URL = 'https://backend.antiwaste.shop:8000/api/';
// export const API_BASE_URL = 'http://127.0.0.1:8000/api/';
